// extracted by mini-css-extract-plugin
export default {"to":"SearchExamReviewList_to__yJrb2","examReviewList":"SearchExamReviewList_examReviewList__G-gxi"};